var avalon = require("avalon"),
    $ = require("jquery"),
    ajax = require("ajax"),
    dialog = require("dialog"),
    popup = require("popup"),
    WebUploader = require("webuploader"),
    managePop;

var vmodel = avalon.define({
    $id: "articleUpdateController",
    title: "",
    keyWord: "",
    subtitle: "",
    isAdmin: "",
    imgSrc: "",
    imgChecked: false,
    imgSelected: "1",
    updateUrl: "",
    showManagePop: function() {
        managePop.show();
    },
    updateImg: function() {}
});
vmodel.$watch("imgSelected", function() {});
// 定义上传图片组件
function initImagesUploader(config) {
    var fileMaxSize = 1024 * 1024 * 2;
    var uploader = WebUploader.create({
        auto: true,
        swf: "/frontcommon_assets/swf/Uploader.swf",
        server: config.server || "",
        pick: config.id || "",
        accept: {
            title: "Images",
            extensions: "gif,jpg,jpeg,bmp,png",
            mimeTypes: "image/gif,image/jpg,image/jpeg,image/png"
        },
        fileVal: "thefile",
        fileSingleSizeLimit: fileMaxSize,
        duplicate: true
    });
    uploader.on("uploadSuccess", function(file, response) {
        if (response.type == "succ") {
            config.callback && config.callback(response.msg.fileurl);
        } else {
            dialog.alert("上传失败");
        }
    });
    uploader.on("beforeFileQueued", function(file) {
        if (file.size > fileMaxSize) {
            dialog.alert("文件大小超过2M限制");
            return false;
        }
        // else if(vmodel.images.length>=5){
        //     popup.alert('最多上传5张图片');
        //     return false;
        // }
    });
}

export default {
    init: function() {
        vmodel.title = window.server.title;
        vmodel.isAdmin = window.server.is_admin;
        vmodel.imgSrc = window.server.bannerImg || "";
        vmodel.updateUrl = window.server.updateUrl;
        vmodel.uploadUrl = window.server.uploadUrl;
        if (vmodel.imgSrc) {
            vmodel.imgChecked = true;
        }
        // 初始化弹窗组件
        var p = popup.init().initPop;
        managePop = new p({
            id: ".manage-pop",
            width: 750,
            height: 500,
            top: "45%",
            okCallback: function() {
                ajax.postWithFail(vmodel.updateUrl, {
                    keyword: vmodel.keyWord,
                    subtitle: vmodel.subtitle,
                    show_img: vmodel.imgSelected,
                    banner_img: vmodel.imgSrc
                }).done(function(response) {
                    if (response.type == "succ") {
                        dialog.alert("推广成功");
                    }
                });
            },
            cancelCallback: function() {
                // pop.hide();
            }
        });
        // 上传图片组件
        initImagesUploader({
            id: "#bannerImagesUploader",
            server: vmodel.uploadUrl + "&articleId=",
            callback: function(url) {
                vmodel.imgSrc = url;
                vmodel.imgChecked = true;
            }
        });
        $(".editor-container .public").on("click", "button", function(e) {
            var title = false;
            var input = $(".editor-container .subject input");
            if (input.length > 0) {
                title = $(".editor-container .subject input")
                    .val()
                    .replace("/^s+|s+$/g", "");
            }
            var id = $(".selectWrap select").val();
            var articleId = server.articleId;
            var url = "";
            var data = {};

            if (articleId > 0) {
                url = server.replyUrl;
                data = {
                    article_id: articleId,
                    content: ue.getContent(),
                    title: title,
                    group_id: id,
                    parent_reply_id: server.replyId,
                    ad_img : $('#ad_img').val()
                };
            } else {
                url = server.updateUrl;
                data = {
                    content: ue.getContent()
                };
            }

            var content = ue.getContent(); // 获取编辑器里面的内容
            if (id == 0) {
                dialog.alert("请选择你要发布到的圈子！");
            } else if (title.length === 0 && title !== false) {
                dialog.alert("主题不能为空");
            } else if (title.length > 50) {
                dialog.alert("主题不能超过25个字");
            } else if (content.length === 0) {
                dialog.alert("内容不能为空");
            } else {
                dialog.confirm(
                    "确认要修改？",
                    function() {
                        $.ajax({
                            url: url,
                            data: data,
                            type: "post"
                        }).done(function(res) {
                            if (res.code === 302) {
                                ajax.jump(window.server.loginUrl);
                            } else if (res.type === "err") {
                                dialog.alert(res.msg);
                            } else {
                                if (res.type == "succ") {
                                    ajax.jump(server.articleUrl);
                                } else {
                                    ajax.jump(res.url);
                                }
                            }
                        });
                    },
                    function() {}
                );
            }
        });
    },
    clear: function() {}
};
